import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./ar.json";
import en from "./en.json";

export const STORAGE_KEY = "godo_ui_lang";
export const DEFAULT_LOCALE = "ar";
export const SUPPORTED_LOCALES = ["ar", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

const RTL_LOCALES: Locale[] = ["ar"];

function getStoredLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored as Locale)) {
      return stored as Locale;
    }
    const legacy = localStorage.getItem("erp_ui_lang");
    if (legacy === "en") return "en";
    if (legacy === "ar" || legacy === "bi") return "ar";
  } catch {
    /* ignore storage errors */
  }
  return DEFAULT_LOCALE;
}

export function applyDocumentDirection(locale: string): void {
  const isRtl = RTL_LOCALES.includes(locale as Locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = isRtl ? "rtl" : "ltr";
}

export function persistLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
    if (locale === "ar" || locale === "en") {
      localStorage.setItem("erp_ui_lang", locale);
    }
  } catch {
    /* ignore storage errors */
  }
}

export function changeLocale(locale: Locale): void {
  persistLocale(locale);
  void i18n.changeLanguage(locale);
}

const initialLocale = getStoredLocale();
applyDocumentDirection(initialLocale);

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...SUPPORTED_LOCALES],
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (locale) => {
  applyDocumentDirection(locale);
  document.title = i18n.t("meta.page_title");
});

document.title = i18n.t("meta.page_title");

export default i18n;
